angular.module('impactx.catalogruleresult').controller('CatalogRuleDeletedProductsListCtrl',
    CatalogRuleDeletedProductsListCtrl);

CatalogRuleDeletedProductsListCtrl.$inject = ['$routeParams'];

function CatalogRuleDeletedProductsListCtrl($routeParams)
{
    this.meta = {
        rowTemplate: 'modules/catalogruleresult/templates/catalogruledeletedproductslist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/catalogruleresult/ruledeletedproductslist',
        id: "catalogruledeletedproductslist",
        params: {'cmrliId': $routeParams.id},
        excelParams: {
            params: [{param: 'CMRLIId', intValue: $routeParams.id}]
        },
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    }
}